import React, { forwardRef, useContext } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import LpgConfirmOutline from "@/icons/Lpg/ConfirmOutline";

import { A11yText } from "../A11yText";
import { Icon } from "../Icon";

import { ColorSelectionContext } from "./ColorSelectionContext";

import styles from "./ColorSelection.scss";

const ColorSelectionItem = forwardRef((props, ref) => {
  const { children, color, isLight, checked, ...otherProps } = props;
  const { id } = otherProps;
  const colorSelection = useContext(ColorSelectionContext) || {};
  const itemId =
    id ||
    [colorSelection.id, colorSelection.itemId].filter((part) => part).join("-");
  const isLightColor =
    isLight ||
    color === "#fff" ||
    color === "#FFF" ||
    color === "#ffffff" ||
    color === "#FFFFFF" ||
    color === "white";

  return colorSelection.interactive ? (
    <li ref={ref} className={styles.item}>
      <input
        type="radio"
        id={itemId}
        className={styles.input}
        name={colorSelection.name}
        onChange={(event) => colorSelection.onChange(children, event)}
        value={children}
        checked={
          colorSelection.value === children ||
          (colorSelection.value === "" && checked)
        }
        {...otherProps}
      />
      <label
        htmlFor={itemId}
        className={cx(styles.label, {
          [styles.labelLight]: isLightColor,
        })}
        style={{ backgroundColor: color }}
      >
        <A11yText>{children}</A11yText>
      </label>
      <span className={styles.icon}>
        <Icon icon={LpgConfirmOutline} size={Icon.Size.small} />
      </span>
    </li>
  ) : (
    <li className={styles.nonInteractiveItem}>
      <span
        className={cx(styles.nonInteractiveElement, {
          [styles.nonInteractiveElementLight]: isLightColor,
        })}
        style={{ backgroundColor: color }}
      >
        <A11yText>{children}</A11yText>
      </span>
    </li>
  );
});

ColorSelectionItem.propTypes = {
  children: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  isLight: PropTypes.bool,
  checked: PropTypes.bool,
};

ColorSelectionItem.defaultProps = {
  isLight: false,
  checked: false,
};

ColorSelectionItem.displayName = "ColorSelection.Item";

export default ColorSelectionItem;
